import {
	IInitialFormData,
	TTypeOfEditVideoStudioModalWindow,
} from './editVideoStudioModalState/editVideoStudioModalContext';
import { IUpdateVideoStudio } from 'types';

export enum EditVideoStudioActionTypes {
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetInitialFormData {
	type: EditVideoStudioActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditVideoStudioActionTypes.SET_ALL_DATA;
	payload: {
		id: string;
		name: string;
	};
}

interface IChangeName {
	type: EditVideoStudioActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetDataForSubmit {
	type: EditVideoStudioActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IUpdateVideoStudio | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditVideoStudioActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditVideoStudioModalWindow;
	};
}

interface IResetSelectedControls {
	type: EditVideoStudioActionTypes.RESET_FIELDS;
}

export type TEditVideoStudioAction =
	| ISetInitialFormData
	| ISetAllData
	| IChangeName
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
